export default __webpack_public_path__ + "static/media/Shirt6.e7928b90.jpeg";